import AutoScrollTop from './AutoScrollTop';

export default AutoScrollTop;
